import React, { useCallback } from 'react';

import { create } from '@fhs/zustand';
import LegacyReplaceIncentiveModal from '@fhs-legacy/frontend/src/components/replace-incentive-modal';
import { IncentiveType } from '@fhs-legacy/frontend/src/components/replace-incentive-modal/types';

import { IDialogCallbacks } from '../types';

interface IReplaceIncentiveUiStore {
  isOpen: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
  show: (callbacks: IDialogCallbacks) => void;
  close: () => void;
}

export const useReplaceIncentiveUiStore = create<IReplaceIncentiveUiStore>(set => ({
  isOpen: false,
  onConfirm: () => {},
  onDismiss: () => {},
  show: (callbacks: IDialogCallbacks) =>
    set({ isOpen: true, onConfirm: callbacks.onConfirm, onDismiss: callbacks.onDismiss }),
  close: () => set({ isOpen: false, onConfirm: () => {}, onDismiss: () => {} }),
}));

export const ReplaceIncentiveModal = () => {
  const { isOpen, close, onConfirm, onDismiss } = useReplaceIncentiveUiStore();

  const handleConfirm = useCallback(() => {
    if (onConfirm) {
      onConfirm();
    }
    close();
  }, [close, onConfirm]);

  const handleDismiss = useCallback(() => {
    if (onDismiss) {
      onDismiss();
    }
    close();
  }, [close, onDismiss]);

  return (
    <>
      {isOpen && (
        <LegacyReplaceIncentiveModal
          incentiveType={IncentiveType.INCENTIVE}
          onConfirm={handleConfirm}
          onDismiss={handleDismiss}
          isOpen={isOpen}
        />
      )}
    </>
  );
};
